export const IMAGE_SIZE_LIMIT = 15 * 1024 * 1024 // 50Mbs
export const VIDEO_SIZE_LIMIT = 50 * 1024 * 1024 // 100Mbs

export const VIDEO_UPLOAD_STATUS = {
  PREPARING: "preparing",
  READY: "ready"
}
